module.exports = __webpack_public_path__ + "img/book-dead.e781cc38.svg";